<template>
  <div class="contenBox">
    <div class="contenBox_top">
      <div>
        <div class="dataList1">
          <div class="dalaAbs">
            {{ currentData.BOOK_NAME }}
          </div>
          <p style="margin-top: 18px;">
            <span class="booktime">{{ listData.CREATE_DATE }}</span>
            <span style="color: #999999;font-size: 13px;margin-left: 16px;">彭祖世家网</span>
            <span style="color: #999999;font-size: 13px;margin-left: 16px;">{{ listData.USER_NAME }}</span>
            <span v-if="listData.SHOW_ABSTRACT" class="ab_span">{{ listData.SHOW_ABSTRACT }}</span>
            <span style="display: block;padding: 0 35px" v-html="listData.SHOW_TEXT" />
          </p>
        </div>
      </div>
    </div>
    <ul class="showulnav">
      <li :class="currentIndex===1?'active':'noactive'" @click="handelNav(1)">
        目录
      </li>
      <span>/</span>
      <li :class="currentIndex===2?'active':'noactive'" @click="handelNav(2)">
        谱文
      </li>
      <span>/</span>
      <li :class="currentIndex===3?'active':'noactive'" @click="handelNav(3)">
        谱系
      </li>
    </ul>
    <div style="overflow: hidden;width: 100%;">
      <div v-show="currentIndex===1" class="dataList1">
        <Mulu :list="muluData1" />
        <Mulu :list="muluData2" />
        <Mulu :list="muluData3" />
        <div v-if="muluData1.length<=0&&muluData2.length<=0&&muluData3.length<=0" style="font-size: 20px;font-weight: 600;color: #A19D9E;text-align: center;padding: 20px 0">
          暂无数据
        </div>
      </div>
      <div v-show="currentIndex===2" class="dataList1">
        <div v-if="puwenData.count>0" style="padding-top: 20px;">
          <span style="margin-left: 20px;">共收录有</span><span class="redmark">{{ puwenData.count }}</span><span>篇谱文</span>
        </div>
        <div v-for="(item,index) in puwenData.listMapData" :key="index">
          <div class="lislist">
            <div class="noImg">
              <a class="nameshow" :href="'/checkRead?id='+item.ARTICLE_ID+'&type=2'" target="_blank">
                {{ item.ARTICLE_NAME }}
              </a>
              <!--<div class="content_cext" v-html="item.PAGE_CONETENT " />-->
            </div>
          </div>
        </div>
        <div v-if="puwenData.count>0" class="pagina_box">
          <el-pagination
            :small="isSmall"
            :pager-count="pagecount"
            :current-page="params1.index"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="10"
            :layout="layoutType"
            :total="puwenData.count"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
          />
        </div>
        <div v-else style="font-size: 20px;font-weight: 600;color: #A19D9E;text-align: center;padding: 20px 0">
          暂无数据
        </div>
      </div>
      <div v-show="currentIndex===3" class="dataList1">
        <div v-if="puxiData.count>0" style="padding-top: 20px;">
          <span style="margin-left: 20px;">共收录有</span><span class="redmark">{{ puxiData.count }}</span><span>篇谱系</span>
        </div>
        <div v-for="(item,index) in puxiData.listMapData" :key="index">
          <div class="lislist">
            <div class="noImg">
              <a class="nameshow" :href="'/checkRead?id='+item.TREE_ID+'&type=3'" target="_blank">
                {{ item.TREE_NAME }}
              </a>
              <span style="float: right;color: #999999;font-size: 12px;font-weight: 400">{{ item.SUMS }} 条人物记录</span>
            </div>
          </div>
        </div>
        <div v-if="puxiData.count>0" class="pagina_box">
          <el-pagination
            :small="isSmall"
            :pager-count="pagecount"
            :current-page="params2.index"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="10"
            :layout="layoutType"
            :total="puxiData.count"
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
          />
        </div>
        <div v-else style="font-size: 20px;font-weight: 600;color: #A19D9E;text-align: center;padding: 20px 0">
          暂无数据
        </div>
      </div>
      <!--<div v-show="currentIndex===4" class="dataList1">-->
      <!--<div v-if="renwuData.count>0">-->
      <!--<span>共有</span><span>{{ renwuData.count }}</span><span>个人物</span>-->
      <!--</div>-->
      <!--<div v-for="(item,index) in renwuData.listMapData" :key="index">-->
      <!--<div style="padding: 20px 0;border-bottom: 1px solid #EDEDED">-->
      <!--<div v-if="item.NODE_PHOTO" style="display: inline-block;width: 200px;height: 134px;font-size: 0;vertical-align: top">-->
      <!--<img style="width: 200px;height: 134px;" :src="item.NODE_PHOTO" alt="">-->
      <!--</div>-->
      <!--<div :class="item.NODE_PHOTO?'hasImg':'noImg'">-->
      <!--<p style="display: inline-block;font-size: 18px;font-weight: 600">-->
      <!--{{ item.NODE_NAME }}-->
      <!--</p>-->
      <!--<span class="content_cext">-->
      <!--{{ item.NODE_CAREER_DESC }}-->
      <!--</span>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div v-if="renwuData.count>0" style="text-align: center;margin-top: 20px;" class="pagina_box">-->
      <!--<el-pagination-->
      <!--:current-page="params3.index"-->
      <!--:page-sizes="[10, 20, 30, 50]"-->
      <!--:page-size="10"-->
      <!--layout="total, sizes, prev, pager, next, jumper"-->
      <!--:total="renwuData.count"-->
      <!--@size-change="handleSizeChange3"-->
      <!--@current-change="handleCurrentChange3"-->
      <!--/>-->
      <!--</div>-->
      <!--<div v-else style="font-size: 20px;font-weight: 600;color: #A19D9E">-->
      <!--暂无数据-->
      <!--</div>-->
      <!--</div>-->
    </div>
  </div>
</template>
<script>
import { getBookListCataLogList } from '@/api/api.js'
import request from '@/utils/request'
import Mulu from '@/components/muluBook/index.vue'
export default {
  components: { Mulu },
  filters: {
    changeHTML: function(val) {
      return val.replace(/<\/?.+?>/g, '')
    },
    changeShidai: value => {
      if (value) {
        var numToZHCNStr = function(num, yearBol) {
          var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
          var numStr = parseInt(num).toString().split('')
          if (isNaN(parseInt(num))) {
            numStr = ['0']
          }
          if (yearBol) {
            var Str = ''
            for (var i = 0; i < numStr.length; i++) {
              Str += chnNumChar[parseInt(numStr[i])]
            }
            return Str
          } else {
            if (numStr.toString() == '1,0') {
              return '十'
            }
            if (numStr.length == 1) {
              return chnNumChar[parseInt(numStr[0])]
            } else if (numStr.length == 2) {
              if (parseInt(numStr[0]) == 1) {
                return '十' + chnNumChar[parseInt(numStr[1])]
              } else {
                return chnNumChar[parseInt(numStr[0])] + chnNumChar[parseInt(numStr[1])]
              }
            } else {
              var Str2 = ''
              for (var i = 0; i < numStr.length; i++) {
                Str2 += chnNumChar[parseInt(numStr[i])]
              }
              return Str2
            }
          }
        }
        var changnum = function(str) {
          var newarry = str.split(',')
          if (newarry.length > 1) {
            var newstr = ''
            for (let i = 0; i < newarry.length; i++) {
              var item = newarry[i]
              if (item.split('=').length > 1) {
                var newitem = item.split('=')[0] + '(' + '第' + numToZHCNStr(item.split('=')[1]) + '世' + ')'
                newstr += newitem
                if (i < newarry.length - 1) {
                  newstr += '、'
                }
              } else {
                item += ','
                newstr += item
              }
            }
            return newstr
          } else {
            if (str.indexOf('=') !== -1) {
              return str.split('=')[0] + '(' + '第' + numToZHCNStr(str.split('=')[1]) + '世' + ')'
            } else {
              return str
            }
          }
        }
        return changnum(value)
      } else {
        return ''
      }
    }
  },
  props: ['listData', 'currentData'],
  inject: ['reload'],
  data() {
    return {
      isSmall: false,
      pagecount: 5,
      layoutType: 'total, sizes, prev, pager, next, jumper',
      muluData1: [],
      muluData2: [],
      muluData3: [],
      currentIndex: 1,
      peng1: require('@/static/pushuimg1.png'),
      puwenData: [],
      puxiData: [],
      renwuData: [],
      params1: {
        index: 1,
        size: 10,
        // bookId: this.$route.query.sourceId
        bookId: this.$route.query.sourceId
      },
      params2: {
        index: 1,
        size: 10,
        bookId: this.$route.query.sourceId
      },
      params3: {
        index: 1,
        size: 10,
        bookId: this.$route.query.sourceId
      }
    }
  },
  mounted() {
    this.isphone()
    this.handelNav(1)
  },
  methods: {
    handelNav(index) {
      this.currentIndex = index
      if (index === 1) {
        getBookListCataLogList({ bookId: this.$route.query.sourceId }).then(res => {
          this.muluData1 = res.data.chapterlistTree
          this.muluData2 = res.data.loglistTree
          // console.log(this.muluData2)
          this.muluData3 = res.data.appendixlistTree
        })
      }
      if (index === 2) {
        this.params1.index = 1
        this.fetchData('/portalBook/getListArticleList', this.params1, 1)
      }
      if (index === 3) {
        this.params2.index = 1
        this.fetchData('/portalBook/getTreeList', this.params2, 2)
      }
      if (index === 4) {
        this.params3.index = 1
        this.fetchData('/portalBook/getNodeList', this.params3, 3)
      }
    },
    handleSizeChange1(size) {
      this.params1.size = size
      this.fetchData('/portalBook/getListArticleList', this.params1, 1)
    },
    handleCurrentChange1(page) {
      this.params1.index = page
      this.fetchData('/portalBook/getListArticleList', this.params1, 1)
    },
    handleSizeChange2(size) {
      this.params2.size = size
      this.fetchData('/portalBook/getTreeList', this.params2, 2)
    },
    handleCurrentChange2(page) {
      this.params2.index = page
      this.fetchData('/portalBook/getTreeList', this.params2, 2)
    },
    handleSizeChange3(size) {
      this.params3.size = size
      this.fetchData('/portalBook/getNodeList', this.params3, 3)
    },
    handleCurrentChange3(page) {
      this.params3.index = page
      this.fetchData('/portalBook/getNodeList', this.params3, 3)
    },
    fetchData(url, params, index) {
      request({
        url: url,
        method: 'post',
        params: params
      }).then(res => {
        if (index === 1) {
          this.puwenData = res.data
        }
        if (index === 2) {
          this.puxiData = res.data
        }
        if (index === 3) {
          this.renwuData = res.data
        }
      })
    },
    isphone() {
      var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
      if (is_mobi) {
        this.layoutType = 'total, prev,pager, next'
        this.isSmall = true
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .booktime{
    color: #999999;
    font-size: 13px;
    margin-left: 35px;
  }
  .pagina_box{
    text-align: center;
    padding: 20px 0;
  }
  .nameshow{
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    &:hover{
      color: #ed4040;
    }
  }
  .ab_span{
    display: inline-block;
    background-color:#F8F8F8;
    color: #666666;
    width:810px;
    padding: 15px 0px;
    margin: 20px 0;
    margin-left: 35px;
  }
  .lislist{
    padding: 25px 0;
    border-bottom: 1px solid #EDEDED;
    background-color: #fff;
    padding-left: 35px;
  }
  .tuijian{
    overflow: hidden;
    background-color: #fff;
  }
  .contenBox_top{
    background-color: #fff;
    overflow: hidden;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
  .title{
    height: 20px;
    line-height: 20px;
    border-left: 2px solid #ed4040;
    padding-left: 10px;
    font-size: 16px;
    margin-left: 20px;
  }
  .redmark{
    color: #ed4040;
    margin: 0 3px;
  }
  .showulnav{
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }
.contenBox{
    width: 880px;
    overflow: hidden;
        .active{
            font-size: 16px;
            display: inline-block;
            padding: 0 8px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
            color: #ed4040;
            font-weight: 600;
        }
        .noactive{
        font-size: 16px;
        display: inline-block;
        padding: 0 8px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        color: #333333;
        font-weight: 600;
    }
    .dataList1{
       /*padding: 30px;*/
      background-color: #fff;
      .hasImg{
        display: inline-block;width: 600px;
        overflow: hidden;
        height: 130px;
        padding-left: 20px;
        vertical-align: top;
        .content_cext{
          line-height: 20px;
          margin-top: 20px;
          display: inline-block;
          overflow: hidden;
          font-size: 12px;
          color: #666666;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:3;
        }
      }
      .noImg{
        display: inline-block;width: 820px;
        overflow: hidden;
        vertical-align: top;
        .content_cext{
          margin-top: 20px;
          display: inline-block;
          overflow: hidden;
          font-size: 12px;
          line-height: 20px;
          color: #666666;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:3;
        }
      }
    }
}
  .dalaAbs{
    font-size: 18px;
    color: #333333;
    margin-left: 35px
  }
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .dalaAbs{
      margin-left: 0;
    }
    .contenBox_top{
      background-color: #F9F9F9;
      margin-bottom: 0;
      .dataList1{
        background-color: #F9F9F9;
      }
    }
    .contenBox_top{
      p{
       .booktime{
         margin-left: 0;
       }
      }
    }
    .contenBox{
      width: 100%!important;
      ul{
        width: 100%!important;
        white-space: nowrap;
        overflow-x: auto;
        margin-bottom: 0;
        margin-top: 0;
        li{
          width: 60px;
        }
        .noactive{
          width: 60px;
        }
        .active{
          width: 60px;
        }
      }
      .ab_span{
        width: 100%!important;
        margin-left: 0;
      }
      .noImg{
        width: 100%!important;
      }
      .hasImg{
        width: 100%!important;
        height: 110px!important;
        padding-left: 0!important;
      }
      .pagina_box{
        white-space: nowrap;
        overflow-x: auto;
      }
    }
    .el-pagination__jump{
      display: none!important;
    }
    .el-pagination__sizes{
      display: none!important;
    }
  }
</style>

